<template v-if="chartData">
  <div :id="`${chartData.name}ChartWrapper`" class="chart__wrapper">
    <h6 class="chart__title">{{ chartData.title }}</h6>
    <span class="chart__subtitle">{{ chartData.subtitle }}</span>
    <div class="chart__canvas_wrapper">
      <canvas :id="chartData.name"></canvas>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend,
  BarController,
  BarElement,
} from 'chart.js'

Chart.register(
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Legend,
  BarController,
  BarElement,
)

var FRIENDLY_LABELS = {
  INCOME_TOO_LOW: "Income too low",
  INCOME_TOO_HIGH: "Income too high",
  NOT_PERMANENTLY_HOUSED: "Not permanently housed",
  LIVING_WITH_FAMILY_FRIENDS_NOT_ON_LEASE: "Not on a lease",
  NO_PROOF_OF_HOUSING: "No proof of housing",
  NOT_IN_SOCAL: "Not in SoCal",
  NOT_A_GOALS_FIT: "Not a goals fit",
  NOT_ELIGIBLE: "Not eligible",
  TOO_EARLY_IN_UNDERGRAD: "Too early in Undergrad",
  NO_RESPONSE_FROM_NOMINATOR_OR_NOMINEE: "No response",
  OTHER: "Other",
  DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR: "Documentation insufficient or unclear",
}

var COLORS = [
  "#FEDA67",
  "#85BDA6",
  "#BEDCFE",
  "#A23B72",
  "#CC978E",
  "#60495A",
  "#1D5A5F",
  "#67FEDA",
  "#DA67FE",
  "#A685BD",
  "#BDA685",
  "#FEBEDC",
  "#DCFEBE",
  "#72A23B",
  "#3B72A2",
  "#8ECC97",
  "#978ECC",
  "#5A6049",
  "#495A60",
  "#5F1D5A",
  "#5A5F1D",
]


var isDollarSignNeeded = false

export default {
  name: 'ParticipantDropoutReasonBarChart',
  props: {
    barChartData: {
      type: Object,
      default: () => {}
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          name: "ParticipantDropoutReason",
          title: "Participant Dropout Reason",
          subtitle: "Distribution of users by decline reason.",
          data: {
            labels: [],
            datasets: [{
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1
            }]
          }
        }
      }
    },
    charts: {
      type: Array,
      default: () => [],
    },
    isDollarSignNeeded: {
      type: Boolean,
    },
  },
  data() {
    return {
      FRIENDLY_LABELS,
      COLORS,
      config: {
        type: 'bar',
        data: {},
        options: {
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      }
    }
  },
  updated() {
    this.createBarChart()
  },
  mounted() {
    this.createBarChart()
  },
  methods: {
    createBarChart() {
      var dataCopy = {
        labels: [],
        datasets: [],
      }

      let dataset = {
        data: [],
        label: "Dropout Reasons",
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      }

      let colorIndex = 0
      for(let i in this.barChartData) {
        if(this.barChartData[i] && this.barChartData[i]["count"]) {
          let label = this.FRIENDLY_LABELS[this.barChartData[i]["declined_reason"]]
          dataCopy.labels.push(label)
          dataset.data.push(this.barChartData[i]["count"])
          dataset.backgroundColor.push(this.COLORS[colorIndex])
          dataset.borderColor.push(this.COLORS[colorIndex])
          colorIndex++
        }
      }

      dataCopy.datasets.push(dataset)

      const ctx = document.getElementById(this.chartData.name)

      this.config.data = dataCopy

      var chart = new Chart(ctx, this.config)

      const chartWrapper = document.getElementById(`${this.chartData.name}ChartWrapper`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.chart {
  &__wrapper {
    border: 1px solid $soft-gray;
    display: inline-block;
    width: 100%;
    padding: 1em;
  }

  &__subtitle {
    font-style: italic;
  }

  &__title {
    margin-bottom: 0;
    color: $black;
  }

  &__canvas_wrapper {
    position: relative;
  }
}
</style>
